export default "__VITE_ASSET__CPYn2vOP__"